export default {
      id: "mail-usage",
      viewBox: "0 0 26 20",
      url: "/dist/svg/" + "sprite.svg#mail-usage",
      toString: function () {
        return this.url;
      }
    }